import { Routes, Route, Outlet } from 'react-router-dom';
import { TopBar } from './components/TopBar';
import { SiteFooter } from './components/SiteFooter';
import { CookieBanner } from './components/CookieBanner';
import { BackToTop } from './components/BackToTop';
import { HomePage } from './pages/HomePage';
import { CompanyPage } from './pages/CompanyPage';
import { SearchPage } from './pages/SearchPage';
import { InsolvencyFeedPage } from './pages/InsolvencyFeedPage';
import { AuctionFeedPage } from './pages/AuctionFeedPage';
import { CrzFeedPage } from './pages/CrzFeedPage';
import { RiskySuppliersPage } from './pages/RiskySuppliersPage';
import { ListingsFeedPage } from './pages/ListingsFeedPage';
import { ListingDetailPage } from './pages/ListingDetailPage';
import { PostListingPage } from './pages/PostListingPage';
import { MyListingsPage } from './pages/MyListingsPage';
import { AdminListingsPage } from './pages/AdminListingsPage';
import { ToolsPage } from './pages/ToolsPage';
import { PersonsPage } from './pages/PersonsPage';
import { AuthPage } from './pages/AuthPage';
import { AccountPage } from './pages/AccountPage';
import { TermsPage } from './pages/TermsPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { ApiDocsPage } from './pages/ApiDocsPage';
import { PricingPage } from './pages/PricingPage';
import { MetodikaPage } from './pages/MetodikaPage';

// Rebrand v3 (2026-07-18) — späť na JEDEN univerzálny layout s horným TopBarom.
// AppShell sidebar (Fáza 2, 2026-07-15) zrušený na priamu žiadosť usera ("nebude
// lepšie ten sidebar tam nemať... či to nie je rušivé") + v2/v3 Artifact mockupy
// sidebar nikdy nemali — všetky obrazovky kreslili pod navy hornou lištou.
// Mini-watchlist zo sidebaru nemá náhradu v chrome; plný watchlist ostáva na /ucet.
function Layout() {
  return (
    <>
      <TopBar />
      <Outlet />
      <SiteFooter />
      <BackToTop />
    </>
  );
}

export function App() {
  return (
    <>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/prihlasenie" element={<AuthPage />} />
          <Route path="/podmienky" element={<TermsPage />} />
          <Route path="/ochrana-udajov" element={<PrivacyPage />} />
          <Route path="/dokumentacia-api" element={<ApiDocsPage />} />
          <Route path="/cennik" element={<PricingPage />} />
          <Route path="/metodika" element={<MetodikaPage />} />
          <Route path="/firma/:ico" element={<CompanyPage />} />
          <Route path="/firma/:ico/:section" element={<CompanyPage />} />
          <Route path="/vyhladavanie" element={<SearchPage />} />
          <Route path="/insolvencie" element={<InsolvencyFeedPage />} />
          <Route path="/drazby" element={<AuctionFeedPage />} />
          <Route path="/zmluvy" element={<CrzFeedPage />} />
          <Route path="/zmluvy/rizikovi-dodavatelia" element={<RiskySuppliersPage />} />
          <Route path="/inzeraty" element={<ListingsFeedPage />} />
          <Route path="/inzeraty/pridat" element={<PostListingPage />} />
          <Route path="/inzeraty/moje" element={<MyListingsPage />} />
          <Route path="/inzeraty/admin" element={<AdminListingsPage />} />
          <Route path="/inzeraty/:id" element={<ListingDetailPage />} />
          <Route path="/nastroje" element={<ToolsPage />} />
          <Route path="/osoby" element={<PersonsPage />} />
          <Route path="/ucet" element={<AccountPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
      <CookieBanner />
    </>
  );
}
